<div>
    <div class="splash-screen"
      [ngStyle]="{'opacity': opacityChange, 'transition': splashTransition,'display': splashdisplay}">
      <img [attr.src]="loaderLogo" alt="Logo">
      <div class="spinner-border text-info" role="status">
        <span class="sr-only"></span>
      </div>
      <span *ngIf="loaderMessage" >{{loaderMessage}}</span>
    </div>
<router-outlet></router-outlet>
</div>